import { NitroDrawer } from 'nitro-components';

import React, { Component, PropTypes } from 'react';

import DataProvider from '../dataProvider';
import Bookmarks from '../components/Bookmarks';

import { SidePanelHeader } from '../../../../components/factoryComponents';

class BookmarksPanel extends Component {
  close = () => {
    this.props.globalActions.closeBookmarksSidePanel();
    // always set the refreshbookmarks to false on each close -
    // so that we can fetch data from redux store instead of seperate call
    this.props.globalActions.refreshBookmarks(false);
  };

  render() {
    const { fetchingBookmarks, common } = this.props;
    const isOpen = common ? common.openBookmarks : false;

    return (
      <NitroDrawer
        isOpen={isOpen}
        close={this.close}
        width={450}
        padding="20px"
        iconVariant="white"
        closeIconSize={14}>
        {!fetchingBookmarks && (
          <SidePanelHeader
            drilldownTitle="Profile"
            drillUp={this.props.globalActions.openProfileSidePanel}
            rootTitle="Bookmarks"
            key="bookmarksHeader"
          />
        )}
        <Bookmarks onRowClick={this.close} />
      </NitroDrawer>
    );
  }
}
BookmarksPanel.propTypes = {
  globalActions: PropTypes.shape({}),
  common: PropTypes.object,
  fetchingBookmarks: PropTypes.bool,
};

export default DataProvider(BookmarksPanel);



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/containers/BookmarksPanel.js